import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import styles from "../styles/Projects.module.css";
import useScrollReveal from "../hooks/useScrollReveal";

const projects = [
  {
    name: "5Squad",
    tag: "Finance Partnership Website",
    link: "https://5squad-website.pages.dev",
    stack: "React, JavaScript, HTML, CSS",
    description:
      "A responsive business website built end-to-end for a finance partnership firm, from requirement gathering through deployment. Mobile-first UI components, reusable React building blocks, and cross-browser testing kept it fast and consistent everywhere.",
  },
  {
    name: "Radiant Girls Hostel & PG",
    tag: "Hospitality Website",
    link: "https://radiantgirlspg.com/",
    stack: "React, Bootstrap, Google Analytics, Netlify",
    description:
      "A responsive site for a women-only hostel and PG brand, positioned as a safe haven for students and working women. Shipped with SEO optimisation, sitemap generation, canonical URLs, Open Graph metadata, and full mobile responsiveness.",
  },
  {
    name: "Vinay Enterprises",
    tag: "Agri-Commodities Trading",
    link: "https://www.vinay-enterprises.com/",
    stack: "Business Website",
    description:
      "A trust-led website for an agri-commodities trader dealing in edible oils, oilseeds, grains, pulses, and spices. Structured around clear product catalogues and contact pathways to turn visitors into B2B enquiries.",
  },
  {
    name: "MG Food Product",
    tag: "Confectionery Manufacturer",
    link: "https://www.mgfoodproduct.com/",
    stack: "Business Website",
    description:
      "A product-led website for an Indore-based candy and confectionery manufacturer with an export business and multiple sister brands. Built to showcase product ranges, quality standards, and direct customer contact channels.",
  },
  {
    name: "Verity Commodities",
    tag: "Import-Export Trading",
    link: "https://www.veritycommodities.com",
    stack: "Business Website",
    description:
      "A corporate site for a pulses and spices trading company operating across exports, imports, domestic trade, and private labelling. Designed to communicate scale, compliance, and reliability to international buyers.",
  },
  {
    name: "Nanaksar Stones",
    tag: "Granite, Tiles & Bathware",
    link: "https://www.nanaksarstones.com",
    stack: "Business Website",
    description:
      "A visually-driven site for a 20+ year old granite, tile, and bathware supplier in Indore. Built around a lifestyle-led product gallery and brand portfolio to help the showroom convert browsers into walk-ins.",
  },
];

export default function Projects() {
  const [headerRef, headerVisible] = useScrollReveal();

  return (
    <div className={styles.section}>
      <Container>
        <div
          ref={headerRef}
          className={`${styles.header} ${headerVisible ? styles.visible : ""}`}
        >
          <p className={styles.eyebrow}>FREELANCE WORK</p>
          <h2 className={styles.heading}>PROJECTS WE'VE SHIPPED</h2>
          <p className={styles.subheading}>
            A selection of business websites designed, built, and deployed
            under Neko Web Studios &mdash; across finance, hospitality, retail,
            and manufacturing.
          </p>
        </div>
        <Row className={styles.grid}>
          {projects.map((project, index) => (
            <ProjectCard project={project} index={index} key={project.name} />
          ))}
        </Row>
      </Container>
    </div>
  );
}

function ProjectCard({ project, index }) {
  const [cardRef, visible] = useScrollReveal();

  return (
    <Col sm={6} lg={4} ref={cardRef}>
      <a
        href={project.link}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.card} ${visible ? styles.visible : ""}`}
        style={{ transitionDelay: `${(index % 3) * 90}ms` }}
      >
        <div className={styles.cardTop}>
          <span className={styles.tag}>{project.tag}</span>
          <FontAwesomeIcon
            icon={faArrowUpRightFromSquare}
            className={styles.linkIcon}
          />
        </div>
        <h3 className={styles.cardTitle}>{project.name}</h3>
        <p className={styles.cardDescription}>{project.description}</p>
        <p className={styles.stack}>{project.stack}</p>
      </a>
    </Col>
  );
}
